import { useEffect, useState } from "react"
import DataTable from "@/widgets/DataTable"
import {
    getAdminsForApprover,
    bulkSetCourseApprovers
} from "@/api/kuizy"

export default function ApproverModal({ visible, courseIds, onClose }) {

    const [rows, setRows] = useState([])
    const [selectedSet, setSelectedSet] = useState(new Set())
    const [loading, setLoading] = useState(false)

    const [search, setSearch] = useState("")
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const [total, setTotal] = useState(0)

    const fetchList = async () => {
        if (!visible) return

        setLoading(true)
        try {
            const res = await getAdminsForApprover({
                course_ids: courseIds.join(","),
                search,
                page,
                per_page: perPage,
            })

            setRows(res.data.rows)
            setTotal(res.data.total)

            // preload
            const pre = new Set(
                res.data.rows
                    .filter(r => r.is_approver)
                    .map(r => r.id)
            )

            setSelectedSet(pre)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (visible) {
            setSelectedSet(new Set())
            setPage(1)
        }
    }, [visible])

    useEffect(() => {
        fetchList()
    }, [visible, page, perPage])

    if (!visible) return null

    const handleSave = async () => {
        await bulkSetCourseApprovers(courseIds, [...selectedSet])
        onClose()
    }

    const columns = [
        { key: "full_name", title: "ชื่อ" },
        { key: "email", title: "Email" },
    ]

    return (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center">

            <div className="bg-white w-[95vw] h-[90vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
                    <div>
                        <h2 className="text-lg font-semibold">
                            กำหนดผู้อนุมัติ
                        </h2>
                        <p className="text-sm text-gray-500">
                            เลือกผู้ดูแลสำหรับ {courseIds.length} หลักสูตร
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-black text-xl"
                    >
                        ✕
                    </button>
                </div>

                {/* Search Bar */}
                <div className="px-6 py-4 border-b bg-white flex gap-3 items-center">
                    <input
                        placeholder="ค้นหา admin จากชื่อ หรือ email..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={e => e.key === "Enter" && (setPage(1), fetchList())}
                        className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-primary"
                    />

                    <button
                        onClick={() => { setPage(1); fetchList() }}
                        className="bg-primary hover:bg-secondary text-white px-4 py-2 rounded-lg text-sm"
                    >
                        ค้นหา
                    </button>
                </div>

                {/* DataTable Area */}
                <div className="flex-1 px-6 py-4 min-h-0">
                    <DataTable
                        columns={columns}
                        rows={rows}
                        loading={loading}
                        selectable
                        selectedSet={selectedSet}
                        onToggleRow={(key) => {
                            const s = new Set(selectedSet)
                            s.has(key) ? s.delete(key) : s.add(key)
                            setSelectedSet(s)
                        }}
                        rowKey={(row) => row.id}
                        page={page}
                        perPage={perPage}
                        total={total}
                        onPageChange={setPage}
                        onPerPageChange={(val) => {
                            setPage(1)
                            setPerPage(val)
                        }}
                    />
                </div>

                {/* Footer */}
                <div className="px-6 py-4 border-t bg-gray-50 flex justify-between items-center">
                    <div className="text-sm text-gray-600">
                        เลือกแล้ว {selectedSet.size} คน
                    </div>

                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg border text-sm hover:bg-gray-100"
                        >
                            ยกเลิก
                        </button>

                        <button
                            disabled={selectedSet.size === 0}
                            onClick={handleSave}
                            className="px-5 py-2 rounded-lg bg-primary hover:bg-secondary text-white text-sm disabled:opacity-50"
                        >
                            บันทึก
                        </button>
                    </div>
                </div>

            </div>
        </div>
    )

}
